module.exports = __webpack_public_path__ + "img/product-1.d70deb48.png";